// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const omanyte: PokeData = {
  "id": 138,
  "name": "omanyte",
  "height": 4,
  "weight": 75,
  "base_experience": 71,
  "types": [
    PokeType.ROCK,
    PokeType.WATER
  ],
  "api_moves": [
    "bind",
    "sand-attack",
    "horn-attack",
    "leer",
    "bite",
    "water-gun",
    "hydro-pump",
    "surf",
    "rock-throw",
    "withdraw",
    "spike-cannon",
    "constrict",
    "rock-slide",
    "protect",
    "rollout",
    "ancient-power",
    "tickle",
    "mud-shot",
    "rock-blast",
    "brine",
    "shell-smash"
  ],
  "moves": [
    "leer",
    "bite",
    "hydro-pump",
    "rock-throw",
    "rock-slide",
    "protect",
    "ancient-power",
    "mud-shot",
    "rock-blast",
    "brine",
    "rain-dance",
    "rock-smash",
    "water-spout"
  ],
  "evolution_chain": {
    "id": 69,
    "item": null,
    "species": [
      {
        "name": "omanyte",
        "order": 169,
        "types": [
          PokeType.ROCK,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "omastar",
        "order": 170,
        "types": [
          PokeType.ROCK,
          PokeType.WATER
        ],
        "evolves_from_species_id": 138,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 56.25,
    "speed": 35,
    "ability_power": 90
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
